import React from "react";
import {FormGroup, Label, Input, InputProps} from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";

interface Props {
  type: InputProps["type"];
  name: string;
  id: string;
  placeholder?: string;
  label?: string;
  value: string | number | readonly string[];
  dataQAId: string;
  dataElmId: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onFocus: () => void;
  errors: Array<string>;
  disabled: boolean;
  options: Array<{
    label: string;
    value: string | number;
  }>;
  customClassName?: any;
  children?: React.ReactNode;
  rows?: number;
}

class BaseInput extends React.Component<Props, void> {
  render() {
    const {
      id,
      name,
      value,
      label,
      type,
      placeholder,
      dataQAId,
      dataElmId,
      children,
      options,
      errors,
      disabled,
      customClassName,
      rows,
    } = this.props;
    return (
      <FormGroup className={s.formGroup}>
        {label && (
          <Label className={s.label} for={id}>
            {label}:
          </Label>
        )}
        <Input
          type={type}
          name={name}
          id={id}
          placeholder={placeholder}
          className={customClassName ? customClassName : s.input}
          value={value}
          disabled={disabled}
          data-qa-id={dataQAId}
          data-elm-id={dataElmId}
          onChange={this.props.onChange}
          onFocus={this.props.onFocus}
          rows={rows}
        >
          {type === "select"
            ? options &&
              options.map((option, index) => {
                return (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                );
              })
            : null}
        </Input>
        {children}
        {errors && (
          <ul className={s.errorSpan}>
            {errors.map((message, index) => (
              <li data-elm-id={`${dataElmId}_error_message`} key={index}>
                {message}
              </li>
            ))}
          </ul>
        )}
      </FormGroup>
    );
  }
}

export default withStyles(s)(BaseInput);
